var map = {
	"./0-cr1.png": 6817,
	"./0-cr2.png": 4360,
	"./0-cr3.png": 8452,
	"./0-cr4.png": 1122,
	"./PaolaConsorti.png": 6072,
	"./Wolfox1.png": 6828,
	"./Wolfox2.png": 8001,
	"./bubbglegum.jpg": 8749,
	"./donatella.png": 269,
	"./gdf1.png": 7929,
	"./gdf2.png": 1615,
	"./mi.png": 8536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3271;